import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'job-title'
const initialState = {
  list: null,
}

export const search = createApiAction('job-title/search', client.search('/api/hr/job-title'))
export const get = createApiAction('job-title/get', client.retrieve(`/api/hr/job-title/:id`))
export const save = createApiAction('job-title/save', client.save('/api/hr/job-title'))
export const destroy = createApiAction('job-title/delete', client.destroy('/api/hr/job-title/:id'))

const update = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  if (state.list) {
    state.list = found
      ? state.list?.map(item => (found.id === item.id ? action.payload : item))
      : [...state.list, action.payload]
  }
}

const sessionSlice = createSlice({
  name,
  initialState,
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload.id)
      })
  },
})
export default sessionSlice.reducer
